import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";
import { API } from "@/App";

const LanguageContext = createContext({
  lang: "en",
  setLang: () => {},
  t: (key) => key,
  translations: {},
});

export const useLanguage = () => useContext(LanguageContext);

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState("en");
  const [translations, setTranslations] = useState({ en: {}, es: {} });

  useEffect(() => {
    const fetchTranslations = async () => {
      try {
        const res = await axios.get(`${API}/translations`);
        setTranslations(res.data);
      } catch (e) {
        console.error("Failed to fetch translations");
      }
    };
    fetchTranslations();
  }, []);

  const setLang = (newLang) => {
    setLangState(newLang);
    localStorage.setItem("cfc_lang", newLang);
  };

  const t = (key) => {
    return translations[lang]?.[key] || translations["en"]?.[key] || key;
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, translations }}>
      {children}
    </LanguageContext.Provider>
  );
};
